/**
 * Blog Article — FAQ Toggle + Dynamic Sidebar TOC
 * Handles FAQ accordion, dynamic TOC generation from .ba-content h2 headings,
 * smooth scroll, and active heading highlight in sidebar.
 */
(function () {
  /* ---- FAQ TOGGLE (per-item accordion) ---- */
  document.querySelectorAll('.ba-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Preferuj per-item toggle (.ba-faq__item), fallback na .ba-faq pre stare clanky
      var item = btn.closest('.ba-faq__item') || btn.closest('.ba-faq');
      if (!item) return;
      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* ---- DYNAMIC SIDEBAR TOC ---- */
  var tocList = document.getElementById('ba-sidebar-toc-list');
  var content = document.querySelector('.ba-content');
  if (!tocList || !content) return;

  var headings = content.querySelectorAll('h2');
  if (headings.length === 0) return;

  /* Ensure every h2 has an id */
  headings.forEach(function (h2) {
    if (!h2.id) {
      h2.id = h2.textContent
        .trim()
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .substring(0, 60);
    }
  });

  /* Replace static TOC with dynamic one */
  tocList.innerHTML = '';
  headings.forEach(function (h2) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h2.id;
    a.textContent = h2.textContent.replace(/^\d+\.\s*/, '');
    li.appendChild(a);
    tocList.appendChild(li);
  });

  /* Smooth scroll for TOC links */
  tocList.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    e.preventDefault();
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    }
  });

  /* Active heading highlight on scroll */
  var tocLinks = tocList.querySelectorAll('a');
  var headingArr = Array.from(headings);
  var ticking = false;

  function updateActive() {
    var scrollY = window.scrollY + 100;
    var current = null;
    for (var i = headingArr.length - 1; i >= 0; i--) {
      if (headingArr[i].offsetTop <= scrollY) {
        current = headingArr[i].id;
        break;
      }
    }
    tocLinks.forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateActive);
      ticking = true;
    }
  }, { passive: true });

  updateActive();

  /* ---- REORDER end-of-article: Author box + Zdroje section before last CTA ---- */
  var authorBox = document.querySelector('.ba-author');
  var ctaBoxes = content.querySelectorAll('.ba-cta');
  if (ctaBoxes.length > 0) {
    var lastCta = ctaBoxes[ctaBoxes.length - 1];

    /* Move author box before last CTA */
    if (authorBox) {
      lastCta.parentNode.insertBefore(authorBox, lastCta);
    }

    /* Move sources heading (h2#zdroje) + ol.ba-sources before last CTA */
    var zdrojeHeading = content.querySelector('h2#zdroje');
    var sourcesList = content.querySelector('ol.ba-sources');
    if (zdrojeHeading) lastCta.parentNode.insertBefore(zdrojeHeading, lastCta);
    if (sourcesList) lastCta.parentNode.insertBefore(sourcesList, lastCta);
  }
})();
